<template>
  <div
    v-lazy-script="{ name: 'jebbit', src }"
    @loaded="scriptLoaded"
  />
</template>

<script>
  import { lazyScript } from '@/Foundation/Common/code/Scripts/directives/lazyScript/lazyScript';

  export default {
    name: 'Jebbit',

    directives: {
      lazyScript,
    },

    props: {
      companyId: {
        required: true,
        type: String,
      },
      src: {
        required: true,
        type: String,
      },
    },

    mounted() {
      window.JebbitObject = {};
      window.jebbit = window.jebbit || function() {
        (window.jebbit.q = window.jebbit.q || []).push(arguments);
      };
    },

    methods: {
      scriptLoaded() {
        window.jebbit('init', this.companyId);
      },
    },
  };
</script>
